import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function SliderIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('', className)}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13 22.75H11C7.7 22.75 5.71 22.09 5.34 18.74C5.28 18.29 5.25 17.75 5.25 17V7C5.25 6.25 5.28 5.71 5.35 5.23C5.71 1.91 7.7 1.25 11 1.25H13C16.3 1.25 18.29 1.91 18.66 5.26C18.72 5.71 18.75 6.25 18.75 7V17C18.75 17.75 18.72 18.29 18.65 18.77C18.29 22.09 16.3 22.75 13 22.75ZM11 2.75C7.69 2.75 7.06 3.42 6.84 5.42C6.78 5.85 6.75 6.32 6.75 7V17C6.75 17.68 6.78 18.15 6.83 18.55C7.05 20.58 7.69 21.25 11 21.25H13C16.31 21.25 16.94 20.58 17.16 18.58C17.22 18.16 17.25 17.68 17.25 17V7C17.25 6.33 17.22 5.85 17.17 5.45C16.95 3.42 16.31 2.75 13 2.75H11Z'
                fill='currentColor'
            />
            <path
                d='M5.67 19.4201H5.33C2.24 19.4201 1.25 18.4301 1.25 15.3301V8.67008C1.25 5.57008 2.24 4.58008 5.33 4.58008H5.67C5.84 4.58008 5.98 4.58008 6.14 4.59008C6.35 4.60008 6.54 4.70008 6.67 4.87008C6.8 5.04008 6.86 5.24008 6.83 5.45008C6.78 5.85008 6.75 6.32008 6.75 7.00008V17.0001C6.75 17.6801 6.78 18.1501 6.83 18.5501C6.86 18.7601 6.8 18.9701 6.67 19.1301C6.54 19.2901 6.35 19.3901 6.14 19.4101C5.98 19.4201 5.84 19.4201 5.67 19.4201ZM5.27 6.08008C3.08 6.09008 2.75 6.44008 2.75 8.67008V15.3301C2.75 17.5601 3.08 17.9101 5.27 17.9201C5.26 17.6501 5.25 17.3501 5.25 17.0001V7.00008C5.25 6.65008 5.26 6.35008 5.27 6.08008Z'
                fill='currentColor'
            />
            <path
                d='M18.6697 19.4201H18.3297C18.1597 19.4201 18.0197 19.4201 17.8597 19.4101C17.6497 19.4001 17.4597 19.3001 17.3297 19.1301C17.1997 18.9701 17.1397 18.7601 17.1697 18.5501C17.2297 18.1501 17.2497 17.6701 17.2497 17.0001V7.00008C17.2497 6.33008 17.2197 5.85008 17.1697 5.45008C17.1397 5.24008 17.1997 5.03008 17.3297 4.87008C17.4597 4.71008 17.6497 4.61008 17.8597 4.59008C18.0197 4.58008 18.1597 4.58008 18.3297 4.58008H18.6697C21.7597 4.58008 22.7497 5.57008 22.7497 8.67008V15.3301C22.7497 18.4301 21.7597 19.4201 18.6697 19.4201ZM18.7297 6.08008C18.7397 6.35008 18.7497 6.65008 18.7497 7.00008V17.0001C18.7497 17.3501 18.7397 17.6501 18.7297 17.9201C20.9197 17.9101 21.2497 17.5601 21.2497 15.3301V8.67008C21.2497 6.44008 20.9197 6.09008 18.7297 6.08008Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default SliderIcon;

